import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { groupListRes, groupListTodo } from '../../LMS_Redux/LMS_Slices/Masters/GroupList';
import PropagateLoader from "react-spinners/PropagateLoader";
import GroupDetails from './GroupDetails';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import GroupListAction from '../LMS_DATA_TABLE/ActionButtons/GroupList';

export default function GroupList() {

    const dispatch = useDispatch()
    const data = useSelector(state => state.groupList && state.groupList.data && state.groupList.data.data)
    const [loading, setLoading] = useState(true)
    const [detailModal, setDetailModal] = useState(false)
    const [modalLoading, setModalLoading] = useState(true)
    // console.log(modalLoading)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME OF GROUP',
            field: 'group_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED BY',
            field: 'created_by',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: GroupListAction,
            cellRendererParams: {
                detailModal: setDetailModal,
                modalLoading: setModalLoading,
            },
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const group_list_res = () => {
        if (groupListRes && groupListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(groupListTodo({ status: '' })).then(() => group_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Group List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }

            </div>

            <GroupDetails detailModal={detailModal} setDetailModal={setDetailModal} modalLoading={modalLoading} setModalLoading={setModalLoading} />
        </>
    );
}